import { formatDate, DATE_FORMATS } from '@frontend/mwm-ui'

import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'
import type { IUserPublic } from '~/types/user'

import UserCard from '~/components/UserCard'
import { MILLISECONDS_IN_NANO } from '~/const'
import { capitalize } from '~/utils/string'

const CreatedByTSCellRenderer = ({
  data,
}: ICellRendererParams<{ created_at_ts: number; created_by: Pick<IUserPublic, 'name' | 'picture'> }>): ReactElement => {
  if (!data) return <div />

  const { created_at_ts, created_by } = data

  if (!created_by) return <div />

  const { name, picture } = created_by

  return (
    <div className="created-by-cell">
      <UserCard
        name={capitalize(name)}
        picture={picture}
        size="small"
        subInfo={formatDate(created_at_ts / MILLISECONDS_IN_NANO, DATE_FORMATS.DEFAULT_WITH_HOURS)}
      />
    </div>
  )
}

export const CreatedByCellRenderer = ({
  value,
}: ICellRendererParams<unknown, { created_at: number; created_by: IUserPublic }>): ReactElement => {
  if (!value) return <div />

  const { created_at, created_by } = value

  if (!created_by) return <div />

  const { name, picture } = created_by

  return (
    <div className="created-by-cell">
      <UserCard name={capitalize(name)} picture={picture} size="small" subInfo={formatDate(created_at)} />
    </div>
  )
}

export default CreatedByTSCellRenderer
